// extracted by mini-css-extract-plugin
module.exports = {"resourceList":"Faq_resourceList__DBwA1","boxContainer":"Faq_boxContainer__PGFqh","button":"Faq_button__dRcBq","spinnerWrapper":"Faq_spinnerWrapper__1HeWI"};